<template>
  <div style="max-height: 60vh;" class="ts-overflow-y-scroll">
    <table class="ts-w-full ts-mt-3">
      <thead>
        <tr class="ts-bg-gray-200 ts-border-b ts-border-t ts-sticky ts-top-0">
          <th class="ts-px-3 ts-py-2 ts-uppercase ts-w-3">
            <input
              type="checkbox"
              :checked="checkedAll"
              class="ts-w-4 ts-h-4 ts-mr-2 ts-outline-none"
              @change="onHeaderCheckAll"
            />
          </th>
          <th class="ts-px-3 ts-py-2 ts-uppercase ts-w-3">
            {{ $t('borrowingSparePart.no') }}
          </th>
          <th class="ts-px-3 ts-py-2 ts-uppercase ts-w-24">
            {{ $t('borrowingSparePart.borrowingNumber') }}
          </th>
          <th class="ts-px-3 ts-py-2 ts-uppercase ts-w-40">
            {{ $t('borrowingSparePart.barcode') }}
          </th>
          <th class="ts-px-3 ts-py-2 ts-uppercase ts-w-56">
            {{ $t('borrowingSparePart.product') }}
          </th>
          <th class="ts-px-3 ts-py-2 ts-uppercase ts-w-24">
            {{ $t('borrowingSparePart.uom') }}
          </th>
          <th class="ts-px-3 ts-py-2 ts-uppercase ts-w-24 ts-text-center">
            {{ $t('borrowingSparePart.qtyOrder') }}
          </th>
          <th class="ts-px-3 ts-py-2 ts-uppercase ts-w-24 ts-text-center">
            {{ $t('borrowingSparePart.qtyReturn') }}
          </th>
          <th class="ts-px-3 ts-py-2 ts-uppercase ts-w-24 ts-text-center">
            {{ $t('borrowingSparePart.qtyLost') }}
          </th>
          <th
            class="
              ts-px-3 ts-py-2 ts-uppercase ts-w-32 ts-text-right
            "
          >
            {{ $t('borrowingSparePart.unitPrice') }}
          </th>
          <th
            class="
              ts-px-3 ts-py-2 ts-uppercase ts-border-r ts-w-56
            "
          >
            {{ $t('borrowingSparePart.remark') }}
          </th>
        </tr>
      </thead>
      <tbody>
        <template v-for="(p, index) in model.product_detail">
          <tr class="ts-border-b" :key="index">
            <td class="ts-px-3 ts-py-2">
              <input
                type="checkbox"
                v-model="p.checked"
                class="ts-w-4 ts-h-4 ts-mr-2 ts-outline-none"
              />
            </td>
            <td class="ts-px-3 ts-py-2">{{ index + 1 }}</td>
            <td class="ts-px-3 ts-py-2">{{ p.sfo_number }}</td>
            <td class="ts-px-3 ts-py-2">{{ p.barcode }}</td>
            <td class="ts-px-3 ts-py-2">{{ p.product_name }}</td>
            <td class="ts-px-3 ts-py-2">
              <select class="ts-w-full ts-outline-none" v-model="p.uom_id">
                <option
                  v-for="(u, index) in getUomList(p.product_id)"
                  :key="index"
                  :value="u.uom_id"
                >
                  {{ u.uom_name_kh }}
                </option>
              </select>
            </td>
            <td class="ts-px-3 ts-py-2">
              <input
                :value="p.quantity_order"
                type="text"
                class="ts-w-full ts-text-center ts-border ts-rounded ts-py-1"
                readonly
              />
            </td>
            <td class="ts-px-3 ts-py-2">
              <input
                v-model.number="p.quantity_return"
                type="number"
                class="ts-w-full ts-text-center ts-border ts-rounded ts-py-1 focus:ts-outline-none"
                :class="{
                  'ts-border-red-500': errors.has(
                    'product_detail.' + index + '.quantity_return'
                  )
                }"
                :readonly="!p.checked"
              />
            </td>
            <td class="ts-px-3 ts-py-2">
              <input
                v-model.number="p.lost_qty"
                type="number"
                class="ts-w-full ts-text-center ts-border ts-rounded ts-py-1 focus:ts-outline-none"
                :class="{
                  'ts-border-red-500': errors.has(
                    'product_detail.' + index + '.lost_qty'
                  )
                }"
                :readonly="!p.checked"
              />
            </td>
            <td class="ts-px-3 ts-py-2 ts-bg-gray-100">
              <ts-currency-input
                type="text"
                :value="p.sale_price"
                currency="$"
                class="
                  ts-w-full ts-border ts-rounded ts-py-1 ts-text-right ts-px-2
                "
              />
            </td>
            <td class="ts-px-3 ts-py-2 ts-bg-gray-100">
              <input
                type="text"
                class="ts-w-full ts-border ts-rounded ts-py-1 ts-text-left focus:ts-outline-none ts-px-2"
                :class="{
                  'ts-border-red-500': errors.has(
                    'product_detail.' + index + '.remarks'
                  )
                }"
                v-model="p.remarks"
              />
            </td>
          </tr>
          <tr v-if="errors.has('product_detail.' + index + '.product_name')">
            <td colspan="10">
              <b>
                <p class="validate">
                  {{
                    errors.first('product_detail.' + index + '.product_name')
                  }}
                </p>
              </b>
            </td>
          </tr>
        </template>
        <tr>
          <td colspan="5" class="ts-text-right ts-px-3 ts-py-2">
            <strong>{{ $t('borrowingSparePart.total') }} : </strong>
          </td>
          <td class="ts-px-3 ts-py-2 ts-text-center">
            {{ $formatNumber(quantityOrder) }}
          </td>
          <td class="ts-px-2 ts-py-2 ts-text-center ts-pr-6">
            {{ $formatNumber(quantityReturn) }}
          </td>
          <td class="ts-px-5 ts-py-2 ts-text-right">
            {{ '$ ' + $formatNumber(customerTotalAmount) }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
export default {
  props: ['value', 'validate'],
  data() {
    return {
      priceType: 2,
      customerTotalAmount: 0,
      vendorRepTotalAmount: 0,
      quantityOrder: 0,
      quantityReturn: 0,
      model: {},
      errors: new Errors(),
      tempDetails: []
    }
  },
  computed: {
    customerAmount: () => product => {
      return (
        (product.sale_price *
          (product.quantity_order - product.quantity_return) *
          product.customer_percentage) /
        100
      )
    },
    vendorRepAmount: () => product => {
      let price =
        product.vendor_standard_price *
        (product.quantity_order - product.quantity_return)

      return (price * product.vendor_cover_percentage) / 100
    },
    getUomList: vm => productId => {
      let uomList = vm.tempDetails.find(d => d.product_id == productId)
      return uomList ? uomList.unit_of_measures : []
    },
    checkedAll: vm => {
      const checkedItem = vm.model.product_detail.filter(p => p.checked)
      if (checkedItem.length == vm.model.product_detail.length) {
        return true
      } else {
        return false
      }
    }
  },
  created() {
    this.model = this.value
  },
  methods: {
    removeRow() {},
    sumQuantityOrder() {
      this.quantityOrder = 0
      this.model.product_detail.forEach(p => {
        let quantity_order = p.quantity_order ? p.quantity_order : 0
        this.quantityOrder = this.quantityOrder + quantity_order
      })
    },
    sumQuantityReturn() {
      this.quantityReturn = 0
      this.model.product_detail.forEach(p => {
        let quantity_return = p.quantity_return ? p.quantity_return : 0
        this.quantityReturn = this.quantityReturn + quantity_return
      })
    },
    sumCustomerAmount() {
      this.customerTotalAmount = 0
      this.model.product_detail.forEach(p => {
        let CustomerAmount =
          (p.sale_price *
            (p.quantity_order - p.quantity_return) *
            p.customer_percentage) /
          100

        this.customerTotalAmount = this.customerTotalAmount + CustomerAmount
      })
    },
    sumVendorRepAmount() {
      this.vendorRepTotalAmount = 0
      this.model.product_detail.forEach(p => {
        let price =
          p.vendor_standard_price * (p.quantity_order - p.quantity_return)

        let VendorRepAmount = (price * p.vendor_cover_percentage) / 100
        this.vendorRepTotalAmount = this.vendorRepTotalAmount + VendorRepAmount
      })
    },
    onHeaderCheckAll(event) {
      const checked = event.target.checked
      this.model.product_detail.forEach(p => {
        p.checked = checked
      })
    }
  },
  watch: {
    'model.product_detail': {
      handler() {
        this.sumQuantityOrder()
        this.sumQuantityReturn()
        this.sumVendorRepAmount()
        this.sumCustomerAmount()
      },
      deep: true
    },
    validate: function(error) {
      this.errors = new Errors(error.errors)
    }
  }
}
</script>

<style scoped>
.vendor-part {
  background: rgb(255, 255, 255);
}

.vendor-color {
  color: #fc4813;
  font-weight: 700;
}
</style>
